
      var _path, _rect, _rect2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgLock = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 18,
  viewBox: "0 0 24 24",
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M8 9.5V6.889c0-1.032.421-2.02 1.172-2.75A4.059 4.059 0 0 1 12 3c1.06 0 2.078.41 2.828 1.139A3.835 3.835 0 0 1 16 6.889V9.5",
  stroke: "#787878",
  strokeWidth: 1.6,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  x: 11,
  y: 13,
  width: 2,
  height: 4,
  rx: 1,
  fill: "#787878"
})), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
  x: 4.8,
  y: 9.8,
  width: 14.4,
  height: 10.4,
  rx: 1.2,
  stroke: "#787878",
  strokeWidth: 1.6,
  strokeLinejoin: "round"
})));

      const __svgRaw = "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"24\" height=\"18\" viewBox=\"0 0 24 24\" fill=\"none\">\r\n  <path d=\"M8 9.5V6.88889C8 5.85749 8.42143 4.86834 9.17157 4.13903C9.92172 3.40972 10.9391 3 12 3C13.0609 3 14.0783 3.40972 14.8284 4.13903C15.5786 4.86834 16 5.85749 16 6.88889V9.5\" stroke=\"#787878\" stroke-width=\"1.6\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/>\r\n  <rect x=\"11\" y=\"13\" width=\"2\" height=\"4\" rx=\"1\" fill=\"#787878\"/>\r\n  <rect x=\"4.8\" y=\"9.8\" width=\"14.4\" height=\"10.4\" rx=\"1.2\" stroke=\"#787878\" stroke-width=\"1.6\" stroke-linejoin=\"round\"/>\r\n</svg>";

      function __resolveCssVarsInSvg(svgMarkup) {
        if (typeof window === 'undefined' || !document?.documentElement) {
          return svgMarkup;
        }

        const htmlEl = document.documentElement;
        const bodyEl = document.body;

        function __readCustomProperty(name) {
          let v = getComputedStyle(htmlEl).getPropertyValue(name).trim();
          if (!v && bodyEl) {
            v = getComputedStyle(bodyEl).getPropertyValue(name).trim();
          }
          return v;
        }

        function __expandVarToken(fullMatch, seen) {
          if (!seen) seen = new Set();
          const m = String(fullMatch)
            .trim()
            .match(/^var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)$/i);
          if (!m) return fullMatch;
          const varName = m[1];
          const fallbackRaw = m[2] != null ? String(m[2]).trim() : '';
          if (seen.has(varName)) {
            return fallbackRaw || fullMatch;
          }
          seen.add(varName);
          let specified = __readCustomProperty(varName);
          if (!specified) {
            return fallbackRaw || fullMatch;
          }
          specified = specified.trim();
          if (/^var\s*\(/i.test(specified)) {
            return __expandVarToken(specified, seen) || fallbackRaw || fullMatch;
          }
          return specified || fallbackRaw || fullMatch;
        }

        return svgMarkup.replace(
          /var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)/gi,
          (fullMatch) => __expandVarToken(fullMatch, new Set())
        );
      }

      function __getSvg() {
        return __resolveCssVarsInSvg(__svgRaw);
      }

      function __getBg() {
        const resolved =__resolveCssVarsInSvg(__svgRaw);

        const encoded = encodeURIComponent(resolved)
          .replace(/'/g, '%27')
          .replace(/"/g, '%22');
        return "url('data:image/svg+xml;charset=utf-8," + encoded + "')"; }

      export default Object.assign(
        new String(__webpack_public_path__ + "Assets/lock.31eb5f8b2926be36b625b3d2317b8e5a.svg"),
        {
          React: SvgLock,
          svgClassName: undefined,
          svg: __getSvg,
          bg: __getBg
        }
      );
      